import Home from './Home-view';

export default Home;
